import React from "react"
import Link from "gatsby-link";

export default ({ node, className = ``, tag = false, title = false, date = true }) => (
  <div className={className}>
    {node.categories && (
      <span className="cat-links">{title ? 'Posted in ' : ''}
      {node.categories
      .map(category => (
        <Link to={`/category/${category.slug}`} key={category.slug}>
          {category.name}
        </Link>
      ))
      .reduce((prev, curr) => [prev, ', ', curr])}
      </span>
    )}
    {date && <span>
                <span className="sep">/</span>
                <time className="entry-date published" dateTime={node.date}>{node.date}</time>
            </span>
    }
    {tag && node.tags &&
      <span>
        <span className="sep">•</span>
        <span className="tags-links">{title ? 'Tagged ' : ''}
          {node.tags
            .map(tag => (
              <Link to={`/tag/${tag.slug}`} key={tag.slug}>
                {tag.name}
              </Link>
            ))
            .reduce((prev, curr) => [prev, ', ', curr])}
        </span>
      </span>
    }
  </div>
)

export const query = graphql`
  fragment PostIcons on ContentfulBlogPost {
    date: publishDate(formatString: "MMMM DD, YYYY")
    updatedAt(formatString: "MMMM DD, YYYY")
    tags {
      name
      slug
    }
    categories {
      name
      slug
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/PostIcons.js